<template>
  <WizardStep
    v-if="hasEditMerchantSettingsPermission"
    heading=""
    :hideFooter="true"
  >
    <template v-slot:content>
      <b-row
        v-for="(emailnotification, index) in emailnotifications"
        :key="index"
      >
        <b-col class="email-notification-confirmation">
          <KTPortlet
            :id="`emailnotification-${index}`"
            :title="emailnotification.Name"
            :class="confirmemailnotification"
          >
            <template v-slot:body>
              <EmailNotificationForm
                v-model="emailaddresses[emailnotification.SK]"
                :event="emailnotification"
              />
            </template>
          </KTPortlet>
          <b-tooltip :target="`emailnotification-${index}`" triggers="hover">
            <p>
              For mulitple emails seperate them with a comma:
              email1@domain.com,email2@domain.com
            </p>

            {{ emailnotification.Description }}
          </b-tooltip>
        </b-col>
      </b-row>
    </template>
  </WizardStep>
</template>

<script>
import WizardStep from "@/components/wizard/WizardStep";
import MerchantSettingsPermissionsMixin from "@/components/merchantsettings/MerchantSettingsPermissionsMixin.js";
import { API, graphqlOperation } from "aws-amplify";
import EmailNotificationForm from "@/components/merchantsettings/emailnotifications/EmailNotificationForm.vue";
import KTPortlet from "@/views/partials/content/Portlet";

export default {
  mixins: [MerchantSettingsPermissionsMixin],
  components: {
    EmailNotificationForm,
    WizardStep,
    KTPortlet
  },
  props: ["heading"],
  data: () => {
    return {
      emailnotifications: [],
      emailaddresses: {},
      confirmemailnotification: "confirmemailnotification"
    };
  },
  methods: {
    async retrieveNotifications() {
      try {
        const getAllEmailNotifications = `
              query getAllEmailNotifications {
                  getAllEmailNotifications {
                    nextToken
                    emailnotifications {
                      Description
                      Example
                      Name
                      SK
                    }
                  }
              }
            `;
        const getAllEmailNotificationsResponse = await API.graphql({
          ...graphqlOperation(getAllEmailNotifications)
        });

        return getAllEmailNotificationsResponse.data.getAllEmailNotifications
          .emailnotifications;
      } catch (e) {
        this.$logger.error("Error retrieving email notifications");
        this.$logger.error(e);
      }
      return [];
    },
    async retrieveMerchantEmailAddresses() {
      try {
        const getMerchantEmailAddresses = `
              query getMerchantEmailAddresses {
                  getMerchantEmailAddresses
              }
            `;
        const getMerchantEmailAddressesResponse = await API.graphql({
          ...graphqlOperation(getMerchantEmailAddresses)
        });

        return getMerchantEmailAddressesResponse.data.getMerchantEmailAddresses;
      } catch (e) {
        this.$logger.error("Error retrieving merchant email addresses");
        this.$logger.error(e);
      }
    },
    parseEmailAddressesData(notification, emailaddresses) {
      try {
        emailaddresses = JSON.parse(emailaddresses);
      } catch (e) {
        this.$logger.error("Error parsing email addresses");
        this.$logger.error(emailaddresses);
        this.$logger.error(e);
        emailaddresses = {};
      }
      if (!emailaddresses) {
        emailaddresses = {};
      }

      notification.forEach(notification => {
        const notificationName = notification.SK;
        if (!emailaddresses[notificationName]) {
          emailaddresses[notificationName] = {
            addresses: ""
          };
        }
      });

      return emailaddresses;
    },
    async retrieveData() {
      const [emailnotifications, emailaddresses] = await Promise.all([
        this.retrieveNotifications(),
        this.retrieveMerchantEmailAddresses()
      ]);
      this.emailnotifications = emailnotifications;
      this.emailaddresses = this.parseEmailAddressesData(
        emailnotifications,
        emailaddresses
      );
    }
  },
  async mounted() {
    await this.retrieveData();
  }
};
</script>

<style lang="scss" scoped>
.confirmemailnotification {
  max-width: 80%;
  box-shadow: none;
}

.email-notification-confirmation {
  display: flex;
  justify-content: center;
}

@media only screen and (max-width: 1024px) {
  .confirmemailnotification {
    max-width: 100%;
    box-shadow: none;
  }
}
</style>
